module.exports = __webpack_public_path__ + "img/robot@3x.5360f388.png";